import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ls from 'local-storage';
import VoucherTracker from "../components/VoucherTracker";

function VoucherPage() {      
  const navigate = useNavigate();
  const userDetail = ls.get("userDetail") || {};

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [handleDownload, setHandleDownload] = useState(false);

  function handleLogout(){
    ls.remove("skBOToken")
    ls.remove("userDetail")
    navigate("/login")
  }

  useEffect(() => {
    if (!ls.get('skBOToken') || !ls.get('userDetail')) {
      navigate('/login');
    }
  }, []);

  return (
    <>
      <div className="min-h-screen bg-[#2b478e] px-4 py-8 flex justify-center">
        <div className="w-full max-w-7xl bg-white rounded-md shadow-md p-6">
          <div className="relative mb-4">
            <button
              className="absolute top-0 right-0 bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 rounded-full"
              onClick={handleLogout}
            >
              Logout
            </button>

            <div className="flex justify-center">
              <img
                src="/latest-logo.jpg"
                alt="Logo"
                className="w-24 h-24 mb-4 rounded-full object-cover"
              />
            </div>
          </div>

          <center>
            {" "}
            <h1 className="text-2xl font-semibold mb-1">Voucher Tracker <br/>Sukhakala {userDetail.merchant_name ? `x ${userDetail.merchant_name}` : ``}</h1>
          </center>

          <div className="mt-10">

            <div className="flex flex-wrap md:flex-nowrap items-center gap-4 mb-6">
              <div className="relative basis-full md:basis-8/12">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xl">🔍</span>
                <input
                  type="text"
                  placeholder="Search voucher..."
                  className="w-full pl-10 pr-4 py-3 rounded-lg border border-yellow-400 bg-yellow-50 text-lg text-gray-600 placeholder-gray-400 font-medium shadow focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition duration-200"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>

              <div className="basis-full md:basis-4/12">

                <div className="flex flex-nowrap items-center gap-4">

                  <div className="basis-2/3">
                    <select
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e.target.value)}
                      className="w-full py-3 px-4 rounded-lg border border-yellow-400 bg-yellow-50 text-lg text-gray-600 font-medium shadow focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition duration-200"
                    >
                      <option value="">All Status</option>
                      <option value="used">Used</option>
                      <option value="unused">Unused</option>
                    </select>
                  </div>

                  <div className="basis-1/3">
                    <button
                      className="flex items-center justify-center w-full py-3 px-4 rounded-lg bg-green-500 hover:bg-green-600 text-white font-medium shadow focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition duration-200"
                      onClick={() => setHandleDownload(true)}
                    >
                      Download
                    </button>
                  </div>

                </div>

              </div>
            </div>

            <VoucherTracker search={search} statusFilter={statusFilter} handleDownload={handleDownload} setHandleDownload={setHandleDownload} />
          </div>
        </div>
      </div>
    </>
  )
}

export default VoucherPage;
